import { FieldName, PromptType } from 'src/sections/chat-gpt/Form/Form.types';
import { gql } from 'graphql-request';
import { useGraphQLClient } from '@utils/graphql/useGraphQLClient';

type ChatGptApiPayload = {
  promptType: PromptType;
  payloadStrings: {
    key: FieldName;
    value: string;
  }[];
};

type ChatGptApiResponse = {
  textCompletionV2: string;
};

export const useChatGptApiRequest = () => {
  const client = useGraphQLClient();
  const fetchData = async (variables: ChatGptApiPayload) => {
    const query = gql`
      query WRITERSBLOCK($promptType: PromptType!, $payloadStrings: [PayloadStrings!]!) {
        textCompletionV2(promptType: $promptType, payloadStrings: $payloadStrings)
      }
    `;
    const response = await client.request<ChatGptApiResponse>(query, variables);
    return response;
  };
  return {
    fetchData,
  };
};
